<template>
    <div class="text-left mt-16" v-if="currentVara">
        <div v-if="currentVara.abhijit">
            <IconClock height="16" classes="icon good" />
            {{ $t('abhijit') }} 
            <nobr>{{ formatTime(currentVara.abhijit.begin) }} - {{ formatTime(currentVara.abhijit.end) }}</nobr>
        </div>
        <div>
            <IconClock height="16" classes="icon bad" />
            {{ $t('rahukala') }} 
            <nobr>{{ formatTime(currentVara.rahukala.begin) }} - {{ formatTime(currentVara.rahukala.end) }}</nobr>
        </div>
    </div>
</template>

<script>
import IconClock from '@/components/visual/icons/IconClock'
import { mapGetters } from 'vuex'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
export default {
    components: { IconClock },
    mixins: [TimeFormatMixin],
    computed: {
        ...mapGetters('predictions', ['currentVara']),
    },
}
</script>

<i18n locale="ru" lang="yaml">
    abhijit: "Абхиджит-мухурта"
    rahukala: "Раху-Кала"
</i18n>